<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-inner-wrapper" ngDraggable [handle]="ModalHandle">
  <div class="modal-header">
    <h4 class="modal-title">
      <span *ngIf="hotelBookingId">
        {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_VIEW.PREVIEW_ROOMING_LIST.TITLE' | translate }}
        <span> #{{ hotelBookingId }}</span>
      </span>
    </h4>

    <div
      class="btn btn-drag"
      #ModalHandle
      container="body"
      [ngbTooltip]="'REQUESTS.REQUEST_FORM.MOVE_MODAL' | translate"
    >
      <i class="far fa-expand-arrows"></i>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
<!--      <span aria-hidden="true">&times;</span>-->
    </button>
  </div>

  <ng-scrollbar class="modal-body ps">
    <div *ngIf="loading" class="text-center py-4">
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <div *ngIf="!loading && rooms.length" class="table-responsive">
      <table class="table table-bordered table-striped table-sm mb-0">
        <thead>
          <tr>
            <th *ngFor="let column of columns">
              {{ ('HOTELS_BOOKINGS.HOTEL_BOOKINGS_VIEW.PREVIEW_ROOMING_LIST.' + column.toUpperCase()) | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let room of rooms">
            <td *ngFor="let column of columns">{{ formatCell(room[column]) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!loading && !rooms.length" class="text-center py-4">
       {{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_VIEW.PREVIEW_ROOMING_LIST.NO_ROOMS_FOUND' | translate }}
    </div>
  </ng-scrollbar>

  <div class="modal-footer d-flex justify-content-between">

  </div>
</div>
